import {BettingPromotionModuleController} from "../betting-promotion.module.controller";
import {BettingPromotionModuleState} from "../models/betting-promotion.module.state";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import {ACTION_TYPES} from "../../../../../core/consts";
import {BettingPromotionBaseHandler} from "../../../../../core/handlers/betting-promotion/betting-promotion.base.handler";
import {POPUP_DISPLAY} from "../../../../../core/models/popup/consts";
import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import {LocalStorageUtils} from "../../../../../infrastructure/utils/local-storage.utils";
import {PopupsDisplayManager} from "../../../../../core/managers/popups-display.manager";

export class BettingPromotionModuleOnPopupClickHandler extends BettingPromotionBaseHandler {
  state: BettingPromotionModuleState;
  controller: BettingPromotionModuleController;
  type = BETTING_PROMOTION.ACTION_TYPES.onPopupClick;
  static injectables = [...ActionHandler.injectables, LocalStorageUtils, PopupsDisplayManager];

  constructor(localStorageUtils: LocalStorageUtils, popupsDisplayManager: PopupsDisplayManager) {
    super();

    this.localStorageUtils = localStorageUtils;
    this.popupsDisplayManager = popupsDisplayManager;
  }
  action(params) {
    this.controller.action(ACTION_TYPES.bettingPromotionDisplay, {isVisible: false});
    this.appStore.state.appBettingPromotionDisplayModel.localStorageModel.clickType = params.type;

    if (params.type === BETTING_PROMOTION.CLICK_TYPE.notInterested) {
      this.popupsDisplayManager.disablePopup(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.bp);
    }

    this.updateLocalStorageModel();
    if (params.type !== BETTING_PROMOTION.CLICK_TYPE.link) {
      this.sendEvent(params.type)
    }
  }

  sendEvent(type) {
    this.controller.action(BETTING_PROMOTION.ACTION_TYPES.ANALYTICS.onClickHandler, {
      version: this.state.version,
      timesShown: this.state.popupVisibleCounter,
      clickType: type,
      textType: this.state.type,
      bookieId: this.state.bookie.id,
      imageUrl: this.state.imageUrl,
      mainText: this.state.bookie.titleText.aliasName,
      secondaryTextTerm: this.state.bookie.ctaText.aliasName,
    })
  }
}
